/* eslint-disable react/jsx-props-no-spreading, camelcase */
import ACFSelect from "./ACFSelect";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";
import { useMemo } from "react";

const ACFInput = ({
	choices,
	default_value: defaultValue,
	name,
	onBlur,
	onChange,
	placeholder,
	required,
	type,
	value,
	wrapper
}) => {
	const inputProps = useMemo(() => ({
		className: `acf-input acf-input-type-${type} ${wrapper?.class || ""}`,
		defaultValue,
		name,
		onBlur,
		onChange,
		placeholder,
		required,
		value
	}), [value]);

	switch (type) {
	case "select":
		return (
			<ACFSelect {...{
				...inputProps,
				choices
			}}
			/>);
	case "date_picker":
		return <Form.Control type="date" {...inputProps} />;
	default:
		return <Form.Control {...inputProps} />;
	}
};

ACFInput.propTypes = {
	choices: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.shape({})]),
	default_value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	name: PropTypes.string.isRequired,
	onBlur: PropTypes.func,
	onChange: PropTypes.func,
	placeholder: PropTypes.string,
	required: PropTypes.bool,
	type: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	wrapper: PropTypes.shape({
		class: PropTypes.string
	})
};

ACFInput.defaultProps = {
	choices: {},
	default_value: "",
	onBlur: null,
	onChange: null,
	placeholder: "",
	required: false,
	type: "text",
	value: "",
	wrapper: {}
};

export default ACFInput;
